export const HEADER_HEIGHT_MOBILE = 64;
export const HEADER_HEIGHT_DESKTOP = 72;

export const resetContainerPaddings = "calc(-1 * (100vw - 100%) / 2)";
